import React, { memo, useMemo, useState } from 'react';
import { get } from 'lodash';
import { Tooltip, Fade } from '@mui/material';
import { getHintMarkerBaloonPos } from './baloonDimensionService';
import flashIcon from '../../../../images/markers/flash.svg';
import uiLabelsPaths from '../../../../common/services/uiFieldLabelsDictionary';
import { statusLabels } from '../../../../common/constants/statuses';
import { getShowTechnicalInfoFieldsFlag } from '../../../../common/services/AuthenticationRules';

const SimpleMarkerPopup = memo(
  ({
    id,
    toggleZoom,
    onTouchStart,
    data,
    openChangerModal,
    cascadingStyle,
    isMobile,
    mobileHover,
    config,
    $getDimensions,
    $dimensionKey,
    $geoService,
    children,
  }) => {
    const [isPopoverOpen, setPopoverOpen] = useState(false);

    const { ui_labels: uiLabels } = config;
    const isTechnicalInfoFieldsFlagAvailable = getShowTechnicalInfoFieldsFlag(config);

    const hintBaloonPos = useMemo(() => {
      const markerDim = $getDimensions($dimensionKey);
      const mapWidth = $geoService.getWidth();

      return getHintMarkerBaloonPos(240, 110, markerDim.x, markerDim.y, mapWidth);
    }, [$getDimensions, $dimensionKey, $geoService]);

    const calculatedStatus = statusLabels[data.state];

    const handleTouchStart = isMobile
      ? () => {
          setPopoverOpen(true);
          onTouchStart(id);
        }
      : null;
    const handleMouseEnter = isMobile
      ? null
      : () => {
          toggleZoom(false);
          setPopoverOpen(true);
        };

    const handleRequestClose = (forceClose = false) => {
      if (!isMobile || !mobileHover || forceClose) {
        toggleZoom(true);
        setPopoverOpen(false);
      }
    };

    return (
      <Tooltip
        open={isPopoverOpen && (!isMobile || mobileHover)}
        onClose={() => handleRequestClose()}
        disableHoverListener={isMobile}
        TransitionComponent={Fade}
        placement={hintBaloonPos}
        slotProps={{
          tooltip: {
            style: {
              padding: '8px 10px',
            },
          },
          popper: {
            style: {
              boxShadow: 'none',
            },
          },
        }}
        arrow
        title={
          <div className="i2p2-marker-content">
            <div className="container">
              <img className="flash-icon" src={flashIcon} alt="" />
              <strong className="name-caption">
                Name:
                {data.name}
              </strong>
            </div>
            <div className="info-container">
              <p>
                {`${get(uiLabels, uiLabelsPaths.c_uuid, 'Charger ID')}: `}
                <span>{data.id}</span>
              </p>
              <p>
                {`${get(uiLabels, uiLabelsPaths.c_status, 'Status')}: `}
                <span className="capitalized">{calculatedStatus}</span>
              </p>
              <p>
                {`${get(uiLabels, uiLabelsPaths.c_online, 'Online')}: `}
                <span className="capitalized">{data.online}</span>
              </p>
              <p>
                {`${get(uiLabels, uiLabelsPaths.connector_state, 'State')}: `}
                <span className="capitalized">{data.chargerState}</span>
              </p>
              <p>
                {`${get(uiLabels, uiLabelsPaths.p_type, 'Product Type')}: `}
                <span>{data.productType}</span>
              </p>
              {isTechnicalInfoFieldsFlagAvailable && (
                <p>
                  {`${get(uiLabels, uiLabelsPaths.c_product_version, 'Product Version')}: `}
                  <span className="capitalized">{data.productVersion || ''}</span>
                </p>
              )}

              <p>
                {`${get(uiLabels, uiLabelsPaths.product_serial, `${data.productName} Serial Number`)}: `}
                <span className="capitalized">{data.productSerialNumber || ''}</span>
              </p>
            </div>
            <div>
              <p
                className="text-center link"
                onClick={() => {
                  openChangerModal(data);
                  handleRequestClose(true);
                }}
              >
                Click to view more info
              </p>
            </div>
          </div>
        }
      >
        <div style={cascadingStyle} onTouchStart={handleTouchStart} onMouseEnter={handleMouseEnter} className="i2p2-marker">
          {children}
        </div>
      </Tooltip>
    );
  },
);

export default SimpleMarkerPopup;
